import { configureStore } from "@reduxjs/toolkit";
import showAuthSlice from "./slices/showAuthSlice";
import  liveDetailSlice  from "./slices/liveDetailSlice";

const appStore = configureStore({
  reducer: {
    showAuth: showAuthSlice,
    liveDetail:liveDetailSlice,
  },
});

export default appStore;
